<div class="contact-container bg-gray-50 min-h-screen">
  <!-- Hero Section -->
  <section class="relative bg-gradient-to-r from-immovea-navy via-blue-800 to-blue-900 text-white py-12 sm:py-20 lg:py-24">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h1 class="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6">Get in Touch</h1>
      <p class="text-lg sm:text-xl lg:text-2xl text-blue-100 max-w-3xl mx-auto leading-relaxed">Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
    </div>
  </section>

  <!-- Contact Info Cards Section -->
  <section class="py-8 sm:py-12 bg-white border-b">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
        <!-- Email Card -->
        <a href="mailto:immovea.realestate@gmail.com" class="block bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-lg p-6 sm:p-8 hover:shadow-xl transition-all hover:scale-[1.02] active:scale-[0.98]">
          <div class="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br from-immovea-navy to-blue-700 mb-4 sm:mb-6 mx-auto">
            <svg class="h-7 w-7 sm:h-8 sm:w-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
          </div>
          <h3 class="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 text-center">Email Us</h3>
          <p class="text-gray-600 mb-3 sm:mb-4 text-center text-sm sm:text-base">Tap to send an email</p>
          <p class="text-center text-immovea-navy font-semibold text-base sm:text-lg break-all">
            immovea.realestate@gmail.com
          </p>
        </a>

        <!-- Phone Card -->
        <a href="tel:+1234567890" class="block bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl shadow-lg p-6 sm:p-8 hover:shadow-xl transition-all hover:scale-[1.02] active:scale-[0.98]">
          <div class="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 mb-4 sm:mb-6 mx-auto">
            <svg class="h-7 w-7 sm:h-8 sm:w-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
            </svg>
          </div>
          <h3 class="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 text-center">Call Us</h3>
          <p class="text-gray-600 mb-3 sm:mb-4 text-center text-sm sm:text-base">Tap to call directly</p>
          <p class="text-center text-emerald-700 font-semibold text-base sm:text-lg">
            +1 (234) 567-890
          </p>
        </a>

        <!-- Business Hours Card -->
        <div class="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl shadow-lg p-6 sm:p-8 hover:shadow-xl transition-shadow">
          <div class="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 mb-4 sm:mb-6 mx-auto">
            <svg class="h-7 w-7 sm:h-8 sm:w-8 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"></path>
            </svg>
          </div>
          <h3 class="text-xl sm:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 text-center">Business Hours</h3>
          <p class="text-gray-600 mb-3 sm:mb-4 text-center text-sm sm:text-base">We're here to help</p>
          <p class="text-center text-purple-700 font-semibold text-base sm:text-lg">
            Mon - Fri<br/>9:00 AM - 6:00 PM
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- Contact Form Section -->
  <section class="py-12 sm:py-16 lg:py-20">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-8 sm:mb-12">
        <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">Send Us a Message</h2>
        <p class="text-lg sm:text-xl text-gray-600">Fill out the form below and we'll get back to you shortly</p>
      </div>

      <div class="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 lg:p-10">
        <form (ngSubmit)="submitForm()" class="space-y-5 sm:space-y-6">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Name Field -->
            <div>
              <label for="name" class="block text-sm font-bold text-gray-900 mb-2">
                Full Name <span class="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                [(ngModel)]="name"
                name="name"
                placeholder="Karim Khoury"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-xl focus:ring-2 focus:ring-immovea-navy focus:border-immovea-navy outline-none transition ' + (errors()['name'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['name']" class="text-sm text-red-600 mt-2">{{ errors()['name'] }}</p>
            </div>

            <!-- Email Field -->
            <div>
              <label for="email" class="block text-sm font-bold text-gray-900 mb-2">
                Email Address <span class="text-red-500">*</span>
              </label>
              <input
                type="email"
                id="email"
                [(ngModel)]="email"
                name="email"
                placeholder="karim@example.com"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-xl focus:ring-2 focus:ring-immovea-navy focus:border-immovea-navy outline-none transition ' + (errors()['email'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['email']" class="text-sm text-red-600 mt-2">{{ errors()['email'] }}</p>
            </div>
          </div>

          <!-- Phone Field -->
          <div class="grid grid-cols-3 gap-4">
            <!-- Country Code -->
            <div>
              <label for="country_code" class="block text-sm font-bold text-gray-900 mb-2">
                Code <span class="text-red-500">*</span>
              </label>
              <select
                id="country_code"
                [(ngModel)]="country_code"
                name="country_code"
                [class]="'w-full px-2 py-2 sm:px-3 sm:py-2.5 text-xs sm:text-sm border-2 rounded-xl focus:ring-2 focus:ring-immovea-navy focus:border-immovea-navy outline-none transition truncate ' + (errors()['country_code'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              >
                <option *ngFor="let country of countryCodes" [value]="country.code">
                  {{ country.flag }} {{ country.code }}
                </option>
              </select>
              <p *ngIf="errors()['country_code']" class="text-sm text-red-600 mt-2">{{ errors()['country_code'] }}</p>
            </div>

            <!-- Phone Number -->
            <div class="col-span-2">
              <label for="phone" class="block text-sm font-bold text-gray-900 mb-2">
                Phone Number <span class="text-red-500">*</span>
              </label>
              <input
                type="tel"
                id="phone"
                [(ngModel)]="phone"
                name="phone"
                placeholder="03-123-456"
                [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-xl focus:ring-2 focus:ring-immovea-navy focus:border-immovea-navy outline-none transition ' + (errors()['phone'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
                required
              />
              <p *ngIf="errors()['phone']" class="text-sm text-red-600 mt-2">{{ errors()['phone'] }}</p>
            </div>
          </div>

          <!-- Subject Field -->
          <div>
            <label for="subject" class="block text-sm font-bold text-gray-900 mb-2">
              Subject <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="subject"
              [(ngModel)]="subject"
              name="subject"
              placeholder="What is this about?"
              [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-xl focus:ring-2 focus:ring-immovea-navy focus:border-immovea-navy outline-none transition ' + (errors()['subject'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
              required
            />
            <p *ngIf="errors()['subject']" class="text-sm text-red-600 mt-2">{{ errors()['subject'] }}</p>
          </div>

          <!-- Message Field -->
          <div>
            <label for="message" class="block text-sm font-bold text-gray-900 mb-2">
              Message <span class="text-red-500">*</span>
            </label>
            <textarea
              id="message"
              [(ngModel)]="message"
              name="message"
              placeholder="Tell us more about your inquiry..."
              rows="6"
              [class]="'w-full px-3 py-2 sm:py-2.5 border-2 rounded-xl focus:ring-2 focus:ring-immovea-navy focus:border-immovea-navy outline-none transition resize-none ' + (errors()['message'] ? 'border-red-500 bg-red-50' : 'border-gray-300 bg-gray-50 hover:bg-white')"
              required
            ></textarea>
            <p *ngIf="errors()['message']" class="text-sm text-red-600 mt-2">{{ errors()['message'] }}</p>
          </div>

          <!-- Submit Button -->
          <div class="pt-4">
            <button
              type="submit"
              [disabled]="loading()"
              class="w-full bg-gradient-to-r from-immovea-navy to-blue-700 hover:from-blue-900 hover:to-blue-800 text-white font-bold py-4 px-6 rounded-xl transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 text-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02]"
            >
              <span *ngIf="!loading()">
                <svg class="w-6 h-6 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                </svg>
                Send Message
              </span>
              <span *ngIf="loading()" class="flex items-center gap-2">
                <svg class="animate-spin h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Sending...
              </span>
            </button>
          </div>

          <!-- Required Fields Note -->
          <p class="text-sm text-gray-500 text-center pt-2">
            <span class="text-red-500">*</span> Required fields
          </p>
        </form>
      </div>
    </div>
  </section>

  <!-- Why Choose Us Section -->
  <section class="py-12 sm:py-16 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-8 sm:mb-12">
          <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">Why Contact IMMOVÉA?</h2>
          <p class="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">We're committed to providing exceptional service and support</p>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          <div class="text-center">
            <div class="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <svg class="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </div>
            <h3 class="text-base sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Fast Response</h3>
            <p class="text-sm sm:text-base text-gray-600">Quick replies to all inquiries</p>
          </div>

          <div class="text-center">
            <div class="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <svg class="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
              </svg>
            </div>
            <h3 class="text-base sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Expert Advice</h3>
            <p class="text-sm sm:text-base text-gray-600">Professional real estate guidance</p>
          </div>

          <div class="text-center">
            <div class="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <svg class="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h3 class="text-base sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">24/7 Support</h3>
            <p class="text-sm sm:text-base text-gray-600">Always here when you need us</p>
          </div>

          <div class="text-center">
            <div class="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
              <svg class="w-6 h-6 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
            </div>
            <h3 class="text-base sm:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Personal Touch</h3>
            <p class="text-sm sm:text-base text-gray-600">Dedicated to your success</p>
          </div>
        </div>
      </div>
    </section>
  </div>